module.exports = __webpack_public_path__ + "static/images/components/ModernizationOverlay/images/modernization-bg-50.3d74b55d.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/ModernizationOverlay/images/modernization-bg-50.jpg
// module id = 2610
// module chunks = 11